import { Component, OnInit, OnDestroy } from '@angular/core';


@Component({
    selector: 'app-layout-overlapped-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss']
})
export class AppLayoutOverlappedNotificationsComponent implements OnInit, OnDestroy {


    constructor() {
    }

    ngOnInit(){

    }

    ngOnDestroy(): void {
    }
}
